requestAnimationFrame(() => {
  scriptController.executeWhenScriptLoaded(['modal-dialog.js'], () => {
    scriptController.onStyleReady(() => {
      function throttle(func, delay) {
        let lastCall = 0;

        return function(...args) {
          const now = Date.now();
          if (now - lastCall >= delay) {
            lastCall = now;
            func.apply(this, args);
          }
        };
      }

      if (!customElements.get('cart-drawer')) {
        class CartDrawer extends ModalDialog {
          constructor() {
            super();

            if (window.addToCartAction === 'cart_drawer' && !window.location.pathname.includes('/cart')) {
              subscribe(PUB_SUB_EVENTS.cartUpdateFinish, this.show.bind(this));
            }

            this.throttledCheckFooter = throttle(this.updateFooterState.bind(this), 400);
            scriptController.scripts.push('cart-drawer.js');
          }

          show() {
            super.show(...arguments);

            if (window.cartBase) {
              if (typeof window.cartBase.syncCartDrawerDiscounts === 'function') {
                window.cartBase.syncCartDrawerDiscounts();
              }
              if (typeof window.cartBase.refreshCart === 'function') {
                window.cartBase.refreshCart();
              }
            }

            if (Shopify.designMode) return;

            this.startFooterUpdates();
          }

          startFooterUpdates() {
            const update = () => {
              this.throttledCheckFooter();
              this.animationId = requestAnimationFrame(update);
            };
            this.animationId = requestAnimationFrame(update);
          }

          updateFooterState() {
            this.footer = this.querySelector('.cart-drawer__footer');
            this.itemsWrapper = this.querySelector('.cart-drawer__items');
            if (!this.footer || !this.itemsWrapper) return;
            this.items = this.itemsWrapper.querySelectorAll('.cart-drawer-item');
            this.notesDropdown = this.footer.querySelector('.animated-dropdown__dropdown');
            let footerHeight = this.footer.offsetHeight;

            if (this.notesDropdown) {
              footerHeight -= this.notesDropdown.offsetHeight;
            }

            let itemsBottomLimit = this.itemsWrapper.offsetTop + footerHeight;

            this.items.forEach((element, index) => {
              if (index >= 2) return false;
              itemsBottomLimit = itemsBottomLimit + (index === 0 ? element.offsetHeight : element.offsetHeight / 2);
            });

            this.footer.classList[
              themeBase.windowHeight < itemsBottomLimit ? 'add' : 'remove'
            ]('cart-drawer__footer--static');
          }

          hide(callback) {
            cancelAnimationFrame(this.animationId);
            super.hide(callback);
          }
        }

        customElements.define('cart-drawer', CartDrawer);
      }
    }, ['component-cart-drawer']);
  });
});